import React from 'react';
import styled from 'styled-components';
import { useTranslate } from '@bynder/localization';
import { token } from '@bynder/design-system';

export function NoResults() {
	const { translate } = useTranslate();

	return (
		<StyledWrapper>
			<StyledHeading>{translate('spotlight.dropdown.noResults')}</StyledHeading>
			<StyledSubtitle>{translate('spotlight.dropdown.noResults.subtitle')}</StyledSubtitle>
		</StyledWrapper>
	);
}

const StyledWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: ${token.spacing2};
	height: 100%;
	text-align: center;
`;

const StyledHeading = styled.div`
	font-weight: 600;
`;

const StyledSubtitle = styled.div`
	color: ${token.colorTextMuted};
`;
